module.exports = __webpack_public_path__ + "static/peppers-shirt-4db91f653192d918869f12e5744aa090.jpg";